import {
  errorLoading, loaded, responseHandler, errorGetStatus, errorGetText, tokenInterceptor,
  uploading,
  endUploading
} from '../manager/HttpManager'
import { fetchLogoutAction } from './AuthWS'
import Constants from '../constants/Constants'

let urlServer = Constants.UrlsConstants.urlServer

export const datasourcesWS = (state = {
  keyValuesType: [], keyValues: [],
  APIKeyValuesTypes: [], APIKeyValues: [],
  folders: [], files: [],
  planners: [],
  checkins: [], chats: [], resourceManagers: [], dataForms: [], dataMediations: [], generics: []
}, action) => {
  switch (action.type) {
    case Constants.ActionsConstants.DATASOURCES.SET_KEY_VALUES_TYPES:
      return Object.assign({}, state, { keyValuesType: action.datas })
    case Constants.ActionsConstants.DATASOURCES.SET_KEY_VALUES:
      return Object.assign({}, state, { keyValues: action.datas })
    case Constants.ActionsConstants.DATASOURCES.SET_API_KEY_VALUES_TYPES:
      return Object.assign({}, state, { APIKeyValuesTypes: action.datas })
    case Constants.ActionsConstants.DATASOURCES.SET_API_KEY_VALUES:
      return Object.assign({}, state, { APIKeyValues: action.datas })
    case Constants.ActionsConstants.DATASOURCES.SET_FOLDER:
      return Object.assign({}, state, { folders: action.datas })
    case Constants.ActionsConstants.DATASOURCES.SET_FILES:
      return Object.assign({}, state, { files: action.datas })
    case Constants.ActionsConstants.DATASOURCES.SET_PLANNERS:
      return Object.assign({}, state, { planners: action.datas })
    case Constants.ActionsConstants.DATASOURCES.SET_CHECKINS:
      return Object.assign({}, state, { checkins: action.datas })
    case Constants.ActionsConstants.DATASOURCES.SET_CHATS:
      return Object.assign({}, state, { chats: action.datas })
    case Constants.ActionsConstants.DATASOURCES.SET_RESOURCE_MANAGERS:
      return Object.assign({}, state, { resourceManagers: action.datas })
    case Constants.ActionsConstants.DATASOURCES.SET_FORMS:
      return Object.assign({}, state, { dataForms: action.datas })
    case Constants.ActionsConstants.DATASOURCES.SET_GENERICS:
      return Object.assign({}, state, { generics: action.datas })
    case Constants.ActionsConstants.DATASOURCES.SET_DMS:
      return Object.assign({}, state, { dataMediations: action.datas })
    default:
      return state
  }
}

export const setKVT = (data) => {
  return {
    type: Constants.ActionsConstants.DATASOURCES.SET_KEY_VALUES_TYPES,
    datas: data,
  }
}

export const setKV = (data) => {
  return {
    type: Constants.ActionsConstants.DATASOURCES.SET_KEY_VALUES,
    datas: data,
  }
}

export const setAKVT = (data) => {
  return {
    type: Constants.ActionsConstants.DATASOURCES.SET_API_KEY_VALUES_TYPES,
    datas: data,
  }
}

export const setAKV = (data) => {
  return {
    type: Constants.ActionsConstants.DATASOURCES.SET_API_KEY_VALUES,
    datas: data,
  }
}

export const setFolders = (data) => {
  return {
    type: Constants.ActionsConstants.DATASOURCES.SET_FOLDER,
    datas: data,
  }
}

export const setFiles = (data) => {
  return {
    type: Constants.ActionsConstants.DATASOURCES.SET_FILES,
    datas: data,
  }
}

export const setPlanners = (data) => {
  return {
    type: Constants.ActionsConstants.DATASOURCES.SET_PLANNERS,
    datas: data,
  }
}

export const setCheckins = (data) => {
  return {
    type: Constants.ActionsConstants.DATASOURCES.SET_CHECKINS,
    datas: data,
  }
}

export const setChats = (data) => {
  return {
    type: Constants.ActionsConstants.DATASOURCES.SET_CHATS,
    datas: data,
  }
}

export const setResourceManagers = (data) => {
  return {
    type: Constants.ActionsConstants.DATASOURCES.SET_RESOURCE_MANAGERS,
    datas: data,
  }
}

export const setForms = (data) => {
  return {
    type: Constants.ActionsConstants.DATASOURCES.SET_FORMS,
    datas: data,
  }
}

export const setDMs = (data) => {
  return {
    type: Constants.ActionsConstants.DATASOURCES.SET_DMS,
    datas: data,
  }
}

export const setGenerics = (data) => {
  return {
    type: Constants.ActionsConstants.DATASOURCES.SET_GENERICS,
    datas: data,
  }
}

export function keyValuesCall(dispatch, appid, kv, type, keyvalue) {
  function fetchKV() {
    let entryPoint = Constants.UrlsConstants.keyvalueEntryPoint
    let method = Constants.MethodsWSConstants.DATASOURCES.KEYVALUETYPE_LIST + appid + '?sort=label'

    fetch(urlServer + entryPoint + method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setKVT(data))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  function saveKV() {
    let method = Constants.UrlsConstants.keyvalueEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.KEYVALUETYPE_UPDATE + appid
    if (!kv.id) method = Constants.UrlsConstants.keyvalueEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.KEYVALUETYPE_ADD + appid

    fetch(urlServer + method, {
      method: kv.id ? 'PUT' : 'POST',
      headers: Constants.UrlsConstants.header,
      body: JSON.stringify(kv),
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        fetchKV()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function deleteKV() {
    let method = Constants.UrlsConstants.keyvalueEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.KEYVALUETYPE_DELETE + appid + '/' + kv.id

    fetch(urlServer + method, {
      method: 'DELETE',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.deleteSuccess'))
        fetchKV()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.deleteError'))
        }
      })
  }

  function fetchKeyValues() {
    let entryPoint = Constants.UrlsConstants.keyvalueEntryPoint
    let method = Constants.MethodsWSConstants.DATASOURCES.KEYVALUE_LIST + appid + '/' + type.id

    fetch(urlServer + entryPoint + method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setKV(data))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  function saveKeyValue() {
    let method = Constants.UrlsConstants.keyvalueEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.KEYVALUE_UPDATE + appid
    if (!keyvalue.id) method = Constants.UrlsConstants.keyvalueEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.KEYVALUE_ADD + appid + '/' + type.id

    fetch(urlServer + method, {
      method: keyvalue.id ? 'PUT' : 'POST',
      headers: Constants.UrlsConstants.header,
      body: JSON.stringify(keyvalue),
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        fetchKeyValues()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function deleteKeyValue() {
    let method = Constants.UrlsConstants.keyvalueEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.KEYVALUE_DELETE + appid + '/' + keyvalue.id

    fetch(urlServer + method, {
      method: 'DELETE',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.deleteSuccess'))
        fetchKV()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.deleteError'))
        }
      })
  }

  return {
    fetchKV,
    saveKV,
    deleteKV,
    fetchKeyValues,
    saveKeyValue,
    deleteKeyValue,
  }
}

export function apiKeyValuesCall(dispatch, appid, kv, type, keyvalue) {
  function clearKV() {
    dispatch(setKVT([]))
  }

  function fetchKV() {
    let entryPoint = Constants.UrlsConstants.apikeyvalueEntryPoint
    let method = Constants.MethodsWSConstants.DATASOURCES.KEYVALUETYPE_LIST + appid + '?sort=label'

    fetch(urlServer + entryPoint + method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setAKVT(data))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  function saveKV() {
    let method = Constants.UrlsConstants.apikeyvalueEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.KEYVALUETYPE_UPDATE + appid
    if (!kv.id) method = Constants.UrlsConstants.apikeyvalueEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.KEYVALUETYPE_ADD + appid

    fetch(urlServer + method, {
      method: kv.id ? 'PUT' : 'POST',
      headers: Constants.UrlsConstants.header,
      body: JSON.stringify(kv),
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        fetchKV()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function deleteKV() {
    let method = Constants.UrlsConstants.apikeyvalueEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.KEYVALUETYPE_DELETE + appid + '/' + kv.id

    fetch(urlServer + method, {
      method: 'DELETE',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.deleteSuccess'))
        fetchKV()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.deleteError'))
        }
      })
  }

  function fetchKeyValues() {
    let entryPoint = Constants.UrlsConstants.apikeyvalueEntryPoint
    let method = Constants.MethodsWSConstants.DATASOURCES.KEYVALUE_LIST + appid + '/' + type.id

    fetch(urlServer + entryPoint + method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setAKV(data))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  function saveKeyValue() {
    let method = Constants.UrlsConstants.apikeyvalueEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.KEYVALUE_UPDATE + appid
    if (!keyvalue.id) method = Constants.UrlsConstants.apikeyvalueEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.KEYVALUE_ADD + appid + '/' + type.id

    dispatch(uploading())

    fetch(urlServer + method, {
      method: keyvalue.id ? 'PUT' : 'POST',
      headers: Constants.UrlsConstants.header,
      body: JSON.stringify(keyvalue),
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        dispatch(endUploading())
        fetchKeyValues()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function deleteKeyValue() {
    let method = Constants.UrlsConstants.apikeyvalueEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.KEYVALUE_DELETE + appid + '/' + keyvalue.id

    fetch(urlServer + method, {
      method: 'DELETE',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.deleteSuccess'))
        fetchKeyValues()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.deleteError'))
        }
      })
  }

  return {
    clearKV,
    fetchKV,
    saveKV,
    deleteKV,
    fetchKeyValues,
    saveKeyValue,
    deleteKeyValue,
  }
}

export function foldersCall(dispatch, appid, folder, files) {
  function clearFolders() {
    dispatch(setFolders([]))
  }

  function fetchFolders() {
    let entryPoint = Constants.UrlsConstants.filesEntryPoint
    let method = Constants.MethodsWSConstants.DATASOURCES.FOLDERTYPE_LIST + appid + '?sort=label'

    fetch(urlServer + entryPoint + method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setFolders(data))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  function saveFolder() {
    let method = Constants.UrlsConstants.filesEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.FOLDERTYPE_UPDATE + appid
    if (!folder.id) method = Constants.UrlsConstants.filesEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.FOLDERTYPE_ADD + appid

    fetch(urlServer + method, {
      method: folder.id ? 'PUT' : 'POST',
      headers: Constants.UrlsConstants.header,
      body: JSON.stringify(folder),
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        fetchFolders()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function deleteFolder() {
    let method = Constants.UrlsConstants.filesEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.FOLDERTYPE_DELETE + appid + '/' + folder.id

    fetch(urlServer + method, {
      method: 'DELETE',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.deleteSuccess'))
        fetchFolders()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.deleteError'))
        }
      })
  }

  function fetchFiles() {
    let entryPoint = Constants.UrlsConstants.filesEntryPoint
    let method = Constants.MethodsWSConstants.DATASOURCES.FILE_LIST + appid + '/' + folder.id + '?sort=filename'

    fetch(urlServer + entryPoint + method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setFiles(data))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  function saveFile() {
    let method = Constants.UrlsConstants.filesEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.FILE_ADD + appid + '/' + folder.id

    let headers = {
      'authtoken': Constants.UrlsConstants.header.authtoken,
      'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
    }

    dispatch(uploading())

    let uploadPromise = Promise.resolve()
    files.forEach((file) => {
      uploadPromise = uploadPromise.then(() => {
        let form = new FormData()
        form.append('file', file)
        form.append('size', file.size)
        return fetch(urlServer + method, {
          method: 'POST',
          headers: headers,
          body: form,
        })
          .then(response => {
            tokenInterceptor(response)
            return responseHandler(response)
          })
          .then(r => r.json())
          .catch(() => {
            uploadPromise.reject()
          })
      })
    })
    uploadPromise = uploadPromise.then(() => {
      dispatch(loaded('Error.Croutons.uploadSuccess'))
      dispatch(endUploading())
      fetchFiles()
    })
    uploadPromise = uploadPromise.catch(error => {
      if (errorGetStatus(error) === 401) {
        dispatch(errorLoading('Error.Croutons.authExpired'))
        fetchLogoutAction(dispatch).fetchLogout()
      } else {
        dispatch(errorLoading('Error.Croutons.uploadFail'))
      }
    })
  }

  function deleteFile() {
    let method = Constants.UrlsConstants.filesEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.FILE_DELETE + appid + '/' + files.id

    fetch(urlServer + method, {
      method: 'DELETE',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.deleteSuccess'))
        fetchFiles()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.deleteError'))
        }
      })
  }

  return {
    clearFolders,
    fetchFolders,
    saveFolder,
    deleteFolder,
    fetchFiles,
    saveFile,
    deleteFile,
  }
}

export function plannersCall(dispatch, appid, planner) {
  function clearPlanners() {
    dispatch(setPlanners([]))
  }

  function fetchPlanners() {
    let entryPoint = Constants.UrlsConstants.plannersEntryPoint
    let method = Constants.MethodsWSConstants.DATASOURCES.PLANNERS_LIST + appid + '?sort=plannerName'

    fetch(urlServer + entryPoint + method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setPlanners(data))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  function savePlanner() {
    let method = Constants.UrlsConstants.plannersEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.PLANNERS_ADD + appid

    if (planner.id) method = Constants.UrlsConstants.plannersEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.PLANNERS_UPDATE + appid

    fetch(urlServer + method, {
      method: planner.id ? 'PUT' : 'POST',
      headers: Constants.UrlsConstants.header,
      body: JSON.stringify(planner),
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        fetchPlanners()
      })
      .catch(error => {
        let code = errorGetStatus(error)
        let text = errorGetText(error)
        if (code === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else if (code === 400) {
          let message
          if (text === 'SUBSCRIBE_FAILED') {
            message = 'Error.Croutons.subscribePlannerError'
          } else if (text === 'UPDATE_CONFIG_FAILED') {
            message = 'Error.Croutons.updatePlannerConfigError'
          }
          dispatch(errorLoading(message))
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function deletePlanner() {
    let method = Constants.UrlsConstants.plannersEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.PLANNERS_DELETE + appid + '/' + planner.id

    fetch(urlServer + method, {
      method: 'DELETE',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.deleteSuccess'))
        fetchPlanners()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.deleteError'))
        }
      })
  }

  return {
    clearPlanners,
    fetchPlanners,
    savePlanner,
    deletePlanner,
  }
}

export function checkinsCall(dispatch, appid, checkin) {
  function clearCheckins() {
    dispatch(setCheckins([]))
  }

  function fetchCheckins() {
    let entryPoint = Constants.UrlsConstants.checkinsEntryPoint
    let method = Constants.MethodsWSConstants.DATASOURCES.CHECKINS_LIST + appid

    fetch(urlServer + entryPoint + method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setCheckins(data))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  function saveCheckin() {
    let method = Constants.UrlsConstants.checkinsEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.CHECKINS_ADD + appid

    if (checkin.id) method = Constants.UrlsConstants.checkinsEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.CHECKINS_UPDATE + appid

    fetch(urlServer + method, {
      method: checkin.id ? 'PUT' : 'POST',
      headers: Constants.UrlsConstants.header,
      body: JSON.stringify(checkin),
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        fetchCheckins()
      })
      .catch(error => {
        let code = errorGetStatus(error)
        let text = errorGetText(error)
        if (code === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else if (code === 400) {
          let message
          if (text === 'SUBSCRIBE_FAILED') {
            message = 'Error.Croutons.subscribeCheckinError'
          } else if (text === 'UPDATE_CONFIG_FAILED') {
            message = 'Error.Croutons.updateCheckinConfigError'
          }
          dispatch(errorLoading(message))
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function deleteCheckin() {
    let method = Constants.UrlsConstants.checkinsEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.CHECKINS_DELETE + appid + '/' + checkin.id

    fetch(urlServer + method, {
      method: 'DELETE',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.deleteSuccess'))
        fetchCheckins()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.deleteError'))
        }
      })
  }

  return {
    clearCheckins,
    fetchCheckins,
    saveCheckin,
    deleteCheckin,
  }
}

export function chatsCall(dispatch, appid, chat) {
  function clearChats() {
    dispatch(setChats([]))
  }

  function fetchChats() {
    let entryPoint = Constants.UrlsConstants.chatsEntryPoint
    let method = Constants.MethodsWSConstants.DATASOURCES.CHATS_LIST + appid + '?sort=chatName'

    fetch(urlServer + entryPoint + method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setChats(data))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  function saveChat() {
    let method = Constants.UrlsConstants.chatsEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.CHATS_ADD + appid

    if (chat.id) method = Constants.UrlsConstants.chatsEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.CHATS_UPDATE + appid

    fetch(urlServer + method, {
      method: chat.id ? 'PUT' : 'POST',
      headers: Constants.UrlsConstants.header,
      body: JSON.stringify(chat),
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        fetchChats()
      })
      .catch(error => {
        let code = errorGetStatus(error)
        let text = errorGetText(error)
        if (code === 401) {
          fetchLogoutAction(dispatch).fetchLogout()
        } else if (code === 400 && text === 'CHAT_SERVER_FAILED') {
          dispatch(errorLoading('Error.Croutons.chatConfigError'))
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function deleteChat() {
    let method = Constants.UrlsConstants.chatsEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.CHATS_DELETE + appid + '/' + chat.id

    fetch(urlServer + method, {
      method: 'DELETE',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.deleteSuccess'))
        fetchChats()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.deleteError'))
        }
      })
  }

  return {
    clearChats,
    fetchChats,
    saveChat,
    deleteChat,
  }
}

export function resourceManagersCall(dispatch, appid, resourceManager) {
  function clearResourceManagers() {
    dispatch(setResourceManagers([]))
  }

  function fetchResourceManagers() {
    let entryPoint = Constants.UrlsConstants.resourceManagersEntryPoint
    let method = Constants.MethodsWSConstants.DATASOURCES.RESOURCE_MANAGERS_LIST + appid + '?sort=resourceName'

    fetch(urlServer + entryPoint + method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setResourceManagers(data))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  function saveResourceManager() {
    let method = Constants.UrlsConstants.resourceManagersEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.RESOURCE_MANAGERS_ADD + appid

    if (resourceManager.id) method = Constants.UrlsConstants.resourceManagersEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.RESOURCE_MANAGERS_UPDATE + appid

    fetch(urlServer + method, {
      method: resourceManager.id ? 'PUT' : 'POST',
      headers: Constants.UrlsConstants.header,
      body: JSON.stringify(resourceManager),
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        fetchResourceManagers()
      })
      .catch(error => {
        let code = errorGetStatus(error)
        let text = errorGetText(error)
        if (code === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else if (code === 400 && text === 'SUBSCRIBE_FAILED') {
          let message = 'Error.Croutons.subscribeResourceManagerError'
          dispatch(errorLoading(message))
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function deleteResourceManager() {
    let method = Constants.UrlsConstants.resourceManagersEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.RESOURCE_MANAGERS_DELETE + appid + '/' + resourceManager.id

    fetch(urlServer + method, {
      method: 'DELETE',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.deleteSuccess'))
        fetchResourceManagers()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.deleteError'))
        }
      })
  }

  return {
    clearResourceManagers,
    fetchResourceManagers,
    saveResourceManager,
    deleteResourceManager,
  }
}

export function formsCall(dispatch, appid, form) {
  function clearForms() {
    dispatch(setForms([]))
  }

  function fetchForms() {
    let entryPoint = Constants.UrlsConstants.formsEntryPoint
    let method = Constants.MethodsWSConstants.DATASOURCES.FORMS_LIST + appid + '?sort=name'

    return fetch(urlServer + entryPoint + method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setForms(data))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  function saveForm() {
    let method = Constants.UrlsConstants.formsEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.FORMS_ADD + appid

    if (form.id) method = Constants.UrlsConstants.formsEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.FORMS_UPDATE + appid

    fetch(urlServer + method, {
      method: form.id ? 'PUT' : 'POST',
      headers: Constants.UrlsConstants.header,
      body: JSON.stringify(form),
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        fetchForms()
      })
      .catch(error => {
        let code = errorGetStatus(error)
        let text = errorGetText(error)
        if (code === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else if (code === 400 && text === 'FORM_SERVER_FAILED') {
          let message = 'Error.Croutons.subscribeFormError'
          dispatch(errorLoading(message))
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function deleteForm() {
    let method = Constants.UrlsConstants.formsEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.FORMS_DELETE + appid + '/' + form.id

    fetch(urlServer + method, {
      method: 'DELETE',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.deleteSuccess'))
        fetchForms()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.deleteError'))
        }
      })
  }

  return {
    clearForms,
    fetchForms,
    saveForm,
    deleteForm,
  }
}

export function dmsCall(dispatch, appid, dm) {
  function clearDMs() {
    dispatch(setDMs([]))
  }

  function fetchDMs() {
    let entryPoint = Constants.UrlsConstants.dmsEntryPoint
    let method = Constants.MethodsWSConstants.DATASOURCES.DMS_LIST + appid + '?sort=name'

    fetch(urlServer + entryPoint + method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setDMs(data))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  function saveDM() {
    let method = Constants.UrlsConstants.dmsEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.DMS_ADD + appid

    if (dm.id) method = Constants.UrlsConstants.dmsEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.DMS_UPDATE + appid

    fetch(urlServer + method, {
      method: dm.id ? 'PUT' : 'POST',
      headers: Constants.UrlsConstants.header,
      body: JSON.stringify(dm),
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        fetchDMs()
      })
      .catch(error => {
        let code = errorGetStatus(error)
        let text = errorGetText(error)
        if (code === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else if (code === 400 && text === 'DM_SERVER_FAILED') {
          let message = 'Error.Croutons.subscribeDMError'
          dispatch(errorLoading(message))
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function deleteDM() {
    let method = Constants.UrlsConstants.dmsEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.DMS_DELETE + appid + '/' + dm.id

    fetch(urlServer + method, {
      method: 'DELETE',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.deleteSuccess'))
        fetchDMs()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.deleteError'))
        }
      })
  }

  return {
    clearDMs,
    fetchDMs,
    saveDM,
    deleteDM,
  }
}

export function genericsCall(dispatch, appid, generic) {
  function clearGenerics() {
    dispatch(setGenerics([]))
  }

  function fetchGenerics() {
    let entryPoint = Constants.UrlsConstants.genericsEntryPoint
    let method = Constants.MethodsWSConstants.DATASOURCES.GENERICS_LIST + appid + '?sort=name'

    fetch(urlServer + entryPoint + method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setGenerics(data))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  function saveGeneric() {
    let method = Constants.UrlsConstants.genericsEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.GENERICS_ADD + appid

    if (generic.id) method = Constants.UrlsConstants.genericsEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.GENERICS_UPDATE + appid

    fetch(urlServer + method, {
      method: generic.id ? 'PUT' : 'POST',
      headers: Constants.UrlsConstants.header,
      body: JSON.stringify(generic),
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        fetchGenerics()
      })
      .catch(error => {
        let code = errorGetStatus(error)
        let text = errorGetText(error)
        if (code === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else if (code === 400 && text === 'GENERICS_SERVER_FAILED') {
          let message = 'Error.Croutons.subscribeGenericError'
          dispatch(errorLoading(message))
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function deleteGeneric() {
    let method = Constants.UrlsConstants.genericsEntryPoint +
      Constants.MethodsWSConstants.DATASOURCES.GENERICS_DELETE + appid + '/' + generic.id

    fetch(urlServer + method, {
      method: 'DELETE',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        dispatch(loaded('Error.Croutons.deleteSuccess'))
        fetchGenerics()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.deleteError'))
        }
      })
  }

  return {
    clearGenerics,
    fetchGenerics,
    saveGeneric,
    deleteGeneric,
  }
}
